import { getCountries, getCountryCallingCode } from "libphonenumber-js";

const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

// [{ code: "IN", name: "India", dialCode: "+91" }, ...] sorted by name.
// Built from libphonenumber-js (already a dependency) + Intl.DisplayNames so we
// don't hand-maintain a 200-row table.
export const COUNTRIES = getCountries()
  .map((code) => ({
    code,
    name: regionNames.of(code) || code,
    dialCode: `+${getCountryCallingCode(code)}`,
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

// India-first app → default the selector to IN so existing UX is unchanged.
export const DEFAULT_COUNTRY = "IN";

export const findCountry = (code) =>
  COUNTRIES.find((c) => c.code === code) ||
  COUNTRIES.find((c) => c.code === DEFAULT_COUNTRY);
